module.exports = __webpack_public_path__ + "static/media/mailgun.4a8b34a9.svg";